import { Button } from '@/components/Button';
import { MdArrowForward } from 'react-icons/md';

interface Props {
  onNext: () => void;
}

export default function FormSetupTutorialStep1({ onNext }: Props) {
  return (
    <div
      className="relative h-[684px] overflow-hidden rounded-b-md"
      style={{
        backgroundImage:
          'linear-gradient(115.9188648349988deg, var(--semantic/primary_lighten, rgba(237, 248, 255, 1)) 0.26437%, var(--semantic/background/white, rgba(255, 255, 255, 1)) 30.106%, var(--semantic/background/white, rgba(255, 255, 255, 1)) 79.841%, var(--semantic/background/tag/pueple, rgba(238, 233, 254, 1)) 99.736%)',
      }}
    >
      {/* 背景画像 */}
      <div className="absolute inset-x-0 bottom-0 opacity-50" style={{ top: '200px' }}>
        <img
          src="/agent/candidate_forms/tutorial.png"
          alt="フォームモックアップ"
          className="size-full object-contain object-bottom"
        />
      </div>

      <div className="relative z-10 flex flex-col gap-lg pt-[72px] pl-[84px]">
        {/* タイトル部分 */}
        <div className="flex flex-col gap-xs">
          <h2 className="text-base leading-normal font-bold text-primary">
            <span>たったの </span>
            <span className="text-primary">3ステップで設定完了！</span>
          </h2>
          <h1 className="text-5xl leading-[1.4] font-bold text-main">
            エントリーフォームを作成してみよう！
          </h1>
          <p className="w-[471px] text-sm leading-[1.7] font-normal text-black">
            設問を設定するだけで、独自のエントリーフォームを手軽に作成することができます。求職者が入力すると自動でエージェントハブの管理画面に反映されます。
          </p>
        </div>

        {/* 作成ボタン */}
        <div>
          <Button color="primary" size="md" onClick={onNext} className="gap-xxs">
            <span>今すぐ作成してみる</span>
            <MdArrowForward className="size-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
